import React, { useState, useEffect } from 'react';
import { useAuthStore } from '@/stores/useAuthStore';
import { AppRouter } from './routes';
import { BootstrapVideoOverlay } from '@/components/BootstrapVideoOverlay';
import { useDictionaries, useLoadUserCollection } from '@/api/obraz/api.hooks';
import { trackUserEvent } from '@/api/obraz/api';
import { useMyTrackerAuthSync } from '@/hooks';

export const Application: React.FC = () => {
  const [isPlayingVideo, setIsPlayingVideo] = useState(true);
  const [startupDone, setStartupDone] = useState(false);

  const { isLoading: isLoadingDictionaries } = useDictionaries();

  const user = useAuthStore(s => s.user);
  const token = useAuthStore(s => s.token);

  useLoadUserCollection({ enabled: Boolean(token) });
  useMyTrackerAuthSync();

  useEffect(() => {
    const startup = async (): Promise<void> => {
      if (user) {
        trackUserEvent({ type: 'app-open', input: {} });
      }

      setStartupDone(true);
    };
    void startup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isPlayingVideo) {
    return (
      <BootstrapVideoOverlay
        onVideoCompleted={() => setIsPlayingVideo(false)}
      />
    );
  }

  if (!startupDone) return null;

  if (!user) {
    return <AppRouter />;
  }

  const isReadyToRenderApp = Boolean(user) && !isLoadingDictionaries;
  return isReadyToRenderApp ? <AppRouter /> : null;
};
